import {combineReducers} from '@reduxjs/toolkit';
import user from './user';
import organization from './organization';
import company from './company';

const reducer = combineReducers({
    user,
    organization,
   company
});

export default reducer;